import { render, staticRenderFns } from "./widgetDrafts.vue?vue&type=template&id=cd10d930&scoped=true&"
import script from "./widgetDrafts.vue?vue&type=script&lang=js&"
export * from "./widgetDrafts.vue?vue&type=script&lang=js&"
import style0 from "./widgetDrafts.vue?vue&type=style&index=0&id=cd10d930&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd10d930",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VIcon})
